import Vue from 'vue'
import Vuex from 'vuex'
import pathify from '../pathify'
import retire from './stores/RetireModule'
import buyHouse from './stores/BuyHouseModule'
import educationFund from './stores/EducationFundModule'
import {getSbScenarioSurvey} from './func/api'
import {dispatch, make} from "vuex-pathify";

Vue.use(Vuex)
window.vmEvent = {};

const state = {
    moduleName: ''
}
const mutations = make.mutations(state)
const actions = {
    async getSurvey({commit, dispatch}, {module, scenario}) {
        const res = await getSbScenarioSurvey({scenario: scenario})
        store.commit(`${module}/data`, res.data.data)
    },
}
const getters = {}
const modules = {
    retire,
    buyHouse,
    educationFund
}

export default new Vuex.Store({
    plugins: [pathify.plugin], // activate plugin
    state,
    getters,
    actions,
    modules,
    mutations,
})
